import React from "react";
import Navbar from "../components/Navbar/Navbar";
import AuthLayout from "../components/Auth/AuthLayout";
import LoginForm from "../components/Auth/LoginForm";
import loginBg from "./../assets/signup-bg.jpg";

function Login() {
  return (
    <>
      <Navbar />
      <AuthLayout backgroundImage={loginBg}>
        <LoginForm />
      </AuthLayout>
    </>
  );
}

export default Login;
